import { useAppSelector } from "../../../redux/hooks";
import { Dashboard } from "./dashboard";
import { IncompleteProfile } from "./incompleteProfile";

export const Overview = () => {
  const { onboardingCompletionStatus } = useAppSelector((state) => {
    return state.auth;
  });

  return (
    <div className="w-full">
      {onboardingCompletionStatus?.isAllComplete ? (
        <Dashboard />
      ) : (
        <IncompleteProfile />
      )}
    </div>
  );
};
